var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { FileInput } from '@/components/ui/Form/FileInput';
export const FileFieldBase = (props) => {
    const { input, inputProps } = props, fileInputProps = __rest(props, ["input", "inputProps"]);
    const { name, onBlur, onChange, value: _value } = input, restInput = __rest(input, ["name", "onBlur", "onChange", "value"]);
    const onChangeFile = useCallback((event) => {
        const { files } = event.target;
        onChange(files);
        onBlur(files);
    }, [onBlur, onChange]);
    return (_jsx(FileInput, Object.assign({}, fileInputProps, { inputProps: Object.assign(Object.assign({}, restInput), inputProps), name: name, onChange: onChangeFile })));
};
